import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

const DashboardWrapper = styled.div`
  a {
    font-size: 14px;
    text-transform: uppercase;
    margin-right: 32px;
    text-decoration: none;
    color: #666666;
    font-weight: bold;
    &.active,
    &:hover {
      color: var(--orange);
    }
  }
`;
const Dashboard = () => {
  return (
    <DashboardWrapper>
      <h3>Things to do:</h3>
      <NavLink to="/activities">New activity</NavLink>
      <NavLink to="/classes">New class</NavLink>
      <NavLink to="/sessions">New session</NavLink>
      <NavLink to="/sessions">Give stars to student</NavLink>
      <NavLink to="/sessions">Give stars to class</NavLink>
      <h3>Make new users:</h3>
      <NavLink to="/admins">New Admin/Teacjer</NavLink>
      <NavLink to="/students">New Student</NavLink>
    </DashboardWrapper>
  );
};

export default Dashboard;
